export const PRODUCTS_FEATURE_KEY = 'products';
